import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import {
  formatCurrencyShort,
  formatInteger,
  formatPercent,
} from "./dashboardFormat";

// Os quatro números do topo.
//
// Cada um traz uma segunda linha que diz de onde ele sai — "de 900 disponíveis",
// "612 de 840 transações". Sem ela, "68%" não informa se é ocupação da casa ou
// conversão de compra, e era exatamente essa dúvida que a tela antiga deixava.

function Kpi({ label, value, hint }) {
  return (
    <Col xs="12" sm="6" xl="3">
      <Card className="card-shadow mb-3">
        <CardBody>
          <div
            style={{
              fontSize: "11px",
              fontWeight: 600,
              letterSpacing: "0.06em",
              textTransform: "uppercase",
              color: "#74788d",
            }}
          >
            {label}
          </div>
          <div style={{ marginTop: "6px", fontSize: "26px", fontWeight: 700, color: "#1f2937" }}>
            {value}
          </div>
          <div style={{ marginTop: "4px", fontSize: "12px", color: "#74788d" }}>{hint}</div>
        </CardBody>
      </Card>
    </Col>
  );
}

export default function KpiRow({ summary }) {
  const {
    paidAmount = 0,
    paidTickets = 0,
    paidTransactions = 0,
    openedTransactions = 0,
    capacity = null,
    occupancyRate = null,
    averageTicket = 0,
    ticketsPerTransaction = 0,
    conversionRate = 0,
  } = summary ?? {};

  return (
    <Row>
      <Kpi
        label="Receita paga"
        value={formatCurrencyShort(paidAmount)}
        hint={`${formatInteger(paidTransactions)} compra(s) paga(s)`}
      />
      <Kpi
        label="Ingressos pagos"
        value={formatInteger(paidTickets)}
        hint={
          capacity
            ? `de ${formatInteger(capacity)} disponíveis · ${formatPercent(occupancyRate)} da casa`
            : "evento sem lotação definida"
        }
      />
      <Kpi
        label="Ticket médio"
        value={formatCurrencyShort(averageTicket)}
        hint={`${ticketsPerTransaction} ingresso(s) por compra`}
      />
      <Kpi
        label="Conversão"
        value={formatPercent(conversionRate)}
        hint={`${formatInteger(paidTransactions)} de ${formatInteger(openedTransactions)} transações abertas`}
      />
    </Row>
  );
}
